  //よくある質問ページ
$(document).ready(function() {
      $('.faq-accordion_title').click(function() { 
        $(this).next('.faq-accordion_text').slideToggle(200);
        $(this).toggleClass("open",200);
      });
    });


  //商品ページ
$(document).ready(function() {
    $('.product_page-faq-accordion_title').click(function() {  
      $(this).next('.product_page-faq-accordion_text').slideToggle(200);
      $(this).toggleClass("open",200);
    });
  });
$(document).ready(function() {
    $('.product_page-ingredients-accordion_title').click(function() {  
      $(this).next('.product_page-ingredients-accordion_text').slideToggle(200);
      $(this).toggleClass("open",200);
    });
  });